export default function CompanyLogo({ path, pathColor, width, height }) {
  return (
    <div className="group">
      <img className="block group-hover:hidden group-hover:absolute" src={path} width={width} height={height} />
      <img className="hidden group-hover:block absolute group-hover:relative" src={pathColor} width={width} height={height} />
    </div>
  );
}
